import { useState } from 'react';

import { staticRoutes } from 'Deer/constants/routes';
import { useAuthenticatedUser } from 'components/hooks/dataHooks';
import { useToast } from 'components/hooks/useToast';

import { TOAST_STATUSES } from 'constants/ProjectConstants';
import { sendUpdateProfileImageEvent } from 'constants/mixpanelHelper';

import { uploadProfilePhoto } from 'services/employee';

const pattern = /image\/(gif|jpe?g|tiff|png|webp|bmp)$/i;

export const useUploadProfilePhoto = () => {
  const { user: loggedInEmployee } = useAuthenticatedUser();
  const toast = useToast();

  const [isUploading, setIsUploading] = useState(false);

  const uploadProfilePhotoHandler = async (file: File) => {
    try {
      if (!pattern.test(file.type)) {
        toast({
          title: 'Please upload an image file',
          status: TOAST_STATUSES.ERROR,
          position: 'bottom-left',
        });
        return;
      }
      if (file.size > 10 * 1000 * 1000) {
        toast({
          title: 'Image size cannot be more than 10 MB.',
          status: TOAST_STATUSES.ERROR,
          position: 'bottom-left',
        });
        return;
      }
      setIsUploading(true);
      await uploadProfilePhoto({ employeeId: loggedInEmployee.id, fileObject: file });
      sendUpdateProfileImageEvent();
      toast({
        title: 'Successfully updated profile picture!',
        status: TOAST_STATUSES.SUCCESS,
        position: 'bottom-left',
      });
      setTimeout(() => {
        window.location.href = staticRoutes.home;
      }, 1000);
    } catch (error) {
      toast({
        title: error?.message ?? 'Failed to update profile picture!',
        status: TOAST_STATUSES.ERROR,
        position: 'bottom-left',
      });
    } finally {
      setIsUploading(false);
    }
  };

  return { isUploading, uploadProfilePhotoHandler };
};
